import { render, staticRenderFns } from "./ProductComments.vue?vue&type=template&id=119b28c2&scoped=true&"
import script from "./ProductComments.vue?vue&type=script&lang=js&"
export * from "./ProductComments.vue?vue&type=script&lang=js&"
import style0 from "./ProductComments.vue?vue&type=style&index=0&id=119b28c2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b28c2",
  null
  
)

export default component.exports